import React, { memo } from 'react';

const ContactFormSubmitting = () => (
  <div className="modal-body align-center">
    <h1>Sending...</h1>
  </div>
);

export default memo(ContactFormSubmitting);
